import { FC } from "react";
import { CourseCertificate } from "src/api/compliance";

import CertificateList from "../../../components/Certificate/CertificateList";

interface PositionDetailViewProps {
  position: {
    id: number;
    name: string;
    status: string | null;
    validUntil: string | null;
    courseIds?: string[];
  };
  certificateMap: Record<string, CourseCertificate>;
}

const PositionDetailView: FC<PositionDetailViewProps> = ({ position, certificateMap }) => {
  const positionCourseIds = position?.courseIds || [];
  const positionCertificates = positionCourseIds.map((courseId) => certificateMap[courseId]).filter(Boolean);

  return <CertificateList certificates={positionCertificates} variant="default" />;
};

export default PositionDetailView;
